import { useEffect, useState } from 'react';

export const useHasScrolledOnce = () => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (window.scrollY > 0) {
      setHasScrolled(true);
      return;
    }

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setHasScrolled(true);
        window.removeEventListener('scroll', handleScroll);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return hasScrolled;
};
